import { useController } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { FormField, Label, SelectInput } from '@/modules/forms';

import { Fields, SecretType } from '../../../constants';
import type { SecretFormValues } from '../../../schemas';
import * as felaRules from './SecretTypeField.rules';
import { SelectOption } from './SelectOption';

const name = Fields.TYPE;

export const SecretTypeField = () => {
    const {
        field: { ref, ...field },
    } = useController<SecretFormValues, typeof name>({ name });

    return (
        <FormField<SecretFormValues>
            name={name}
            htmlFor={name}
            label={
                <Label>
                    <FormattedMessage id='secret.type.label' />
                </Label>
            }
        >
            <SelectInput
                {...field}
                id={name}
                popupShouldIgnoreParentContainer
                options={Object.values(SecretType).map(type => ({
                    label: <SelectOption type={type} />,
                    value: type,
                }))}
                customOptionStyle={felaRules.option}
            />
        </FormField>
    );
};
